export default "__VITE_ASSET__CKA7BFlR__"